import PropTypes from 'prop-types'
import useScripts from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Scripts/useScripts'
import { useTranslation } from 'react-i18next'
import CreditBoosterEmpty from './CreditBoosterEmpty'
import CreditBoosterContent from './CreditBoosterContent'
import useAdditionalSaleScript from '../AdditionalSales/useAdditionalSaleScript'
import useCreditBooster from './useCreditBooster'

const CreditBooster = ({ country }) => {
  const { t } = useTranslation()
  const { scripts } = useScripts()
  const { scrollToAdditionalSaleTab } = useAdditionalSaleScript()
  const { creditBoosterEnabled } = useCreditBooster(country)

  if (!creditBoosterEnabled) return null

  const scriptArray = scripts && Object.entries(scripts).length > 0 ? Object.values(scripts) : []

  if (scriptArray.length === 0) return <CreditBoosterEmpty t={t} />

  return <CreditBoosterContent t={t} scriptArray={scriptArray} scrollToAdditionalSaleTab={scrollToAdditionalSaleTab} />
}

CreditBooster.propTypes = {
  country: PropTypes.string,
}

export default CreditBooster
